import BootstrapVue from 'bootstrap-vue'
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/es'
import VeeValidate, {
  Validator
} from 'vee-validate'
import es from 'vee-validate/dist/locale/es'
import Vue from 'vue'
import VueNotify from 'vue-notifyjs'
import VueNumeric from 'vue-numeric'
import VueProgressBar from 'vue-progressbar'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2'
import VueStorage from 'vuestorage'
import App from './App.vue'
import AppModal from './components/Modal.component.vue'
import Rating from './components/Rating.component.vue'
import './pollyfills'
import store from './store.js'
/* import DatePicker from 'vue2-datepicker' */
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueAnalytics from 'vue-analytics'
import ThemifyIcon from 'vue-themify-icons'
import vuetify from './plugins/vuetify'
// import ruta from "../static/conf.js";
// const ruta = () => import("../static/conf.js");

import {
  Rate
} from 'element-ui'

import VueJWT from 'vuejs-jwt'

import {
  dom, library
} from '@fortawesome/fontawesome-svg-core'
import {
  fab
} from '@fortawesome/free-brands-svg-icons'
import {
  far
} from '@fortawesome/free-regular-svg-icons'
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

// Plugins
import SideBar from './components/UIComponents/SidebarPlugin'
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'

// router setup
import routes from './routes/routes'

import {
  mix
} from './mixin'
import {
  mixCat
} from './mixinCatalogs'
// library imports
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'jquery/dist/jquery.min.js'
import './assets/css/global.css'
import './assets/sass/demo.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/paper-dashboard.scss'
import './filters'

import Currency from './components/UIComponents/CurrencyNumber.vue'

let optionsjwt = {
  signKey: 'my-secret-fucking-key',
  keyName: 'app-token-declaranet'
}

Vue.use(VueJWT, optionsjwt)

export const eventBus = new Vue()

const config_validate = {
  aria: true,
  classes: true,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'veeFields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'es',
  validity: false,
  useConstraintAttrs: true
}
// import SpinnerPlugin from './spinner.js'
/* import {
  BreedingRhombusSpinner
} from 'epic-spinners'
*/
dom.watch()
library.add(fas, fab, far)

/* Vue.component('date-picker', DatePicker) */
Vue.component('currency', Currency)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.mixin(mix)
Vue.mixin(mixCat)
Vue.component('app-modal', AppModal)
Vue.component('rating', Rating)
Vue.use(VueResource)
Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(VueNumeric)
Vue.use(SideBar)
Vue.use(Rate)
Vue.use(VueStorage)
Vue.component(ThemifyIcon)
/* require('moment/locale/es')

Vue.use(VueMoment) */
/*
Vue.use(SpinnerPlugin)
Vue.component('breeding-rhombus-spinner', BreedingRhombusSpinner)
*/
Vue.use(VueProgressBar, {
  color: 'rgb(249, 185, 0)',
  failedColor: 'red',
  height: '4px'
})

// Vue.use(VeeValidate)
Validator.localize('es', es)

const isCurp = (curp, param = true) => {
  var re = /^[A-Z][A,E,I,O,U,X][A-Z]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]$/

  var validado = curp.match(re)

  if (!validado) {
    return false
  }
  return true // Validado
}

// const isCurp = (curp, param = true) => {
//   var re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
//     validado = curp.match(re);
//   if (curp === "OICH840707MJCRLL07") return true;

//   if (!validado)
//     //Coincide con el formato general?
//     return false;

//   //Validar que coincida el dígito verificador
//   function digitoVerificador(curp17) {
//     //Fuente https://consultas.curp.gob.mx/CurpSP/
//     var diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
//       lngSuma = 0.0,
//       lngDigito = 0.0;
//     for (var i = 0; i < 17; i++)
//       lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
//     lngDigito = 10 - (lngSuma % 10);
//     if (lngDigito == 10) return 0;
//     return lngDigito;
//   }

//   if (validado[2] != digitoVerificador(validado[1])) return false;

//   return true; //Validado
// };

const isRfc = (rfc, param = true) => {
  const re = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$/

  var validado = rfc.match(re)

  if (!validado) {
    return false
  }
  return true
}
// const isRfc = (value, param = true) => {
//   var rfc = value;
//   var aceptarGenerico = true;
//   var suma, digitoEsperado;
//   const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
//   var validado = rfc.match(re);
//   if (!validado) {
//     return false;
//   }
//   //Separar el dígito verificador del resto del RFC
//   const digitoVerificador = validado.pop(),
//     rfcSinDigito = validado.slice(1).join(""),
//     len = rfcSinDigito.length,
//     diccionario = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ",
//     indice = len + 1;
//   if (len == 12) {
//     suma = 0;
//   } else {
//     suma = 481; //Ajuste para persona moral
//   }
//   for (var i = 0; i < len; i++) {
//     suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);
//   }
//   digitoEsperado = 11 - (suma % 11);
//   if (digitoEsperado == 11) {
//     digitoEsperado = 0;
//   } else if (digitoEsperado == 10) {
//     digitoEsperado = "A";
//   }
//   //El dígito verificador coincide con el esperado?
//   if (rfc == "IAPF870205HX4" || rfc == "RALY900508T93" || "LEFJ8506304R2") {
//     return true;
//   } else if (
//     digitoVerificador != digitoEsperado &&
//     (!aceptarGenerico || rfcSinDigito + digitoVerificador != "XAXX010101000")
//   ) {
//     return false;
//   } else if (
//     !aceptarGenerico &&
//     rfcSinDigito + digitoVerificador == "XEXX010101000"
//   ) {
//     return false;
//   }
//   return true;
//   /*
//   // Esta falidacion solo verifica la estructura del RFC
//   // tambien admite la validacion de RFC sin homoclave
//   var rfc = value.toUpperCase();
//   // el signo ? despues de ([a-zA-Z0-9]{3}) determina que puede o no contener esa sección
//   var _rfc_simple="^([a-zA-Z]{3,4})([\\d]{6})([a-zA-Z0-9]{3})?$";
//   // patron del RFC, persona moral
//   var _rfc_pattern_pm = "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
//     "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
//     "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
//     "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";
//   // patron del RFC, persona fisica
//   var _rfc_pattern_pf = "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
//     "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
//     "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
//     "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";
//   // || rfc.match(_rfc_simple)
//   if (rfc.match(_rfc_pattern_pm) || rfc.match(_rfc_pattern_pf) || rfc.match(_rfc_simple)) {
//     return true;
//   } else {
//     return false;
//   } */
// };

Validator.extend('rfc', {
  getMessage: field =>
    'El formato de la RFC no es válido, verifica la información.',
  validate: isRfc
})

Validator.extend('curp', {
  getMessage: field =>
    'El formato de la CURP no es válido, verifica la información.',
  validate: isCurp
})

Validator.extend('uppercase', {
  getMessage: field =>
    'Este campo requiere utilizar solo mayusculas y números.',
  validate: value => {
    if (value.match(/^[A-Z0-9]*$/)) {
      return true
    } else {
      return false
    }
  }
})

const dictionary = {
  es: {
    messages: {
      _default: () => 'El campo no es válido',
      required: () => 'El campo es obligatorio',
      numeric: () => 'El campo debe ser número'
    }
  }
}
// Override and merge the dictionaries
Validator.localize(es)
// Validator.localize('es', dictionary.es);

Vue.use(VeeValidate, config_validate)
locale.use(lang)

var ruta = ''


// ruta = '//declaranet.strc.guanajuato.gob.mx'

// const getRuntimeConfig = async () => {
//   const runtimeConfig = await fetch('./conf.json')
//   return await runtimeConfig.json()
// }

// if (process.env.NODE_ENV === 'development') {
//   Vue.http.options.root = '//localhost:8000/api/'
//   Vue.prototype.$rootUrl = '//localhost:8000'
// } else {
//   getRuntimeConfig().then((Config) => {
//     Vue.http.options.root = Config.ruta + '/index.php/api/'
//     Vue.prototype.$rootUrl = Config.ruta
//   }, (error) => {
//     console.log(error)
//     Vue.http.options.root = '/api/'
//     Vue.prototype.$rootUrl = '/'
//   })
// }

if (process.env.NODE_ENV === 'development') {
  Vue.http.options.root = '//' + window.location.hostname + ':8000/api/'
  Vue.prototype.$rootUrl = '//' + window.location.hostname + ':8000/'
} else if (window.__env) {
  Vue.http.options.root = '//' + window.location.hostname + window.__env.api.base + '/api/'
  Vue.prototype.$rootUrl = '//' + window.location.hostname + window.__env.api.base + '/'
} else {
  Vue.http.options.root = '/api/'
  Vue.prototype.$rootUrl = '/'
}

var TotalLoads = 0
var TotalLoadsDone = 0

Vue.http.interceptors.push(function (request) {
  const token = this.$jwt.getToken()
  const auth = 'Bearer ' + (token || '')
  request.headers.set('Authorization', auth)

  // console.log(request.headers);

  this.$Progress.start()
  // this.$Spinner.show()
  TotalLoads++

  return function (response) {
    TotalLoadsDone++
    if (TotalLoadsDone == TotalLoads) {
      // console.log('!!!');
      this.$Progress.finish()
      // this.$Spinner.hide()
      // this.$Spinner.hide();
      TotalLoads = 0
      TotalLoadsDone = 0
    }
  }
})

window.$ = window.jQuery = require('jquery')

///

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

//
Vue.use(VueAnalytics, {
  id: 'UA-140095545-1',
  router
})

router.beforeEach((to, from, next) => {
  /*
    var token = Vue.prototype.$jwt.hasToken();
    var jwt = '';
    if (token) {
      jwt = Vue.prototype.$jwt.decode();
    }
  */
  var ip_id = localStorage.getItem('app-token-declaranet')

  if (to.path !== '/login' && to.path !== '/busqueda' && !to.path.includes('/recuperapass') && !ip_id) {
    next('/login')
  } else {
    next()
  }
})

new Vue({
  router,
  vuetify,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js